/**
 * Shared placeholder for every tool tile on the Home screen. The site shell
 * ships before any real tool page exists, so every route except Home and
 * Login renders this instead. Swap the route's element for the real page
 * as each tool is built; nothing else about the route needs to change.
 */

import { StateCard } from '@ampersandbrands/ui';

export function ComingSoon({ title }: { title: string }) {
  return (
    <div className="mx-auto w-full max-w-lg pb-24">
      <StateCard
        dashed
        title={title}
        description="This tool is coming soon. It will appear here once it is built."
      />
    </div>
  );
}
